import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { nav } from '../data/site';
import { IconClose, IconMenu } from './Icons';
import { Logo } from './Logo';

export const Navbar: React.FC = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <Link to="/" className="brand" aria-label="Mustafa Gürses — ana sayfa">
          <Logo markSize={34} />
        </Link>
        <nav className="nav-desktop" aria-label="Ana menü">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `nav-link ${isActive ? 'is-active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="header-actions">
          <Link to="/contact" className="btn btn-fill btn-sm header-cta">
            İletişim
          </Link>
          <button
            type="button"
            className="menu-toggle"
            aria-label={open ? 'Menüyü kapat' : 'Menüyü aç'}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <IconClose /> : <IconMenu />}
          </button>
        </div>
      </div>
      <div className={`mobile-nav ${open ? 'is-open' : ''}`} aria-hidden={!open}>
        {nav.map((item) => (
          <NavLink key={item.to} to={item.to} className="mobile-nav-link">
            {item.label}
          </NavLink>
        ))}
        <NavLink to="/contact" className="mobile-nav-link">
          İletişim
        </NavLink>
      </div>
    </header>
  );
};
